import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllStudentLanguages extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("StudentLanguage/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleStudentLanguage extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("StudentLanguage/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
export { GetAllStudentLanguages, GetASingleStudentLanguage };
